import React, { useState } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import 'translations/translations';
import { useTranslation } from 'react-i18next';
import 'theme/iconClasses.css';
import { ContactsTabTable } from 'features/organizations/organizationTabsContent/ContactsTabTable';
import { CreateEditContactDialog } from 'features/organizations/organizationTabsContent/CreateEditContactDialog';

import { primaryColor } from 'theme/theme';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';
import PageSpinner from 'components/spinners/PageSpinner';

const useStyles = makeStyles((theme) => ({
  alignRight: {
    textAlign: 'right',
  },
  marginRight: {
    marginRight: '0.6rem',
  },

  plusIcon: {
    display: 'inline-block',
    fontSize: '1.5rem',
    lineHeight: 0,
    marginRight: '0.5rem',
  },
  addButton: { marginLeft: '0' },
  actionsButton: {
    padding: '0',
  },
  buttonRoot: {
    marginRight: 0,
  },
  tableContainer: {
    marginTop: '1rem',
    marginLeft: '-1.5rem',
    width: 'calc(100% + 3rem)',
  },
  table: {
    color: primaryColor(),
  },
  tableHead: {
    backgroundColor: 'rgba(240, 241, 243, 1)',
    color: primaryColor(),
  },
  tableHeadCell: {
    fontWeight: 'bold',
    color: primaryColor(),
    padding: '0.7rem 1rem 0.5rem 1rem',
  },
  tableCell: {
    color: primaryColor(),
  },
  tableRow: {
    textDecoration: 'none',
  },
  textBold: {
    fontWeight: 'bold',
    color: primaryColor(),
  },
  preDataView: {
    marginTop: '3rem',
    textAlign: 'center',
  },
  error: {
    color: theme.palette.error.main,
  },
  paper: {
    padding: '0',
  },
}));

const ContactsTab: React.FC = () => {
  const { t } = useTranslation(['translations']);
  const classes = useStyles();

  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const contacts = useSelector(
    (state: ApplicationState) => state.organization?.organization?.contacts,
  );

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <PageSpinner isLoading={!contacts}>
        <div className={classes.alignRight}>
          <Button
            onClick={handleOpenDialog}
            variant="contained"
            color="primary"
            className={classes.addButton}
          >
            <span className={classes.plusIcon}>+</span>

            {t('organization_page.contacts.labels.add_contact')}
          </Button>
        </div>

        <ContactsTabTable />
        <CreateEditContactDialog
          isOpen={isDialogOpen}
          handleClose={handleCloseDialog}
        />
      </PageSpinner>
    </>
  );
};

export { ContactsTab };
